import "./index.scss";

interface ITrowelIcon{
    src:string,
    width?: string,
    height?:string;
    className?:string;
    onClick?: ()=>void;
}

const TrowelIcon : React.FC<ITrowelIcon>  = ({ src, width, height, className, onClick})=>{

    const iconStyle = {
        backgroundImage: `url(${src})`,
        width,
        height
    };
    return (
        <>
        <div className={`trwl-icon ${className}`} style={iconStyle} onClick={onClick}>
        </div>
        </>
    );

};

export default TrowelIcon;